import React from 'react';
import { motion } from 'framer-motion';
import { HeartCrack, Calendar, MessageSquareWarning, Wallet } from 'lucide-react';
const pains = [{
  icon: HeartCrack,
  text: 'Se aman, pero últimamente se sienten lejos.'
}, {
  icon: Calendar,
  text: 'La rutina y los niños dejaron la relación en modo "pendientes".'
}, {
  icon: MessageSquareWarning,
  text: 'Te da miedo intentar hablar y terminar en discusión.'
}, {
  icon: Wallet,
  text: 'Quieres reconectar sin depender de una salida o presupuesto.'
}];
export function PainPoints() {
  return <section className="py-12 px-4 bg-[#0f0f16]" data-id="element-121">
      <div className="max-w-3xl mx-auto" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-123">
          <h2 className="text-2xl font-serif text-white mb-2" data-id="element-124">
            Esto es para ti si...
          </h2>
          <div className="h-0.5 w-16 bg-[#ff2d7a] mx-auto rounded-full" data-id="element-125" />
        </motion.div>

        <div className="space-y-3" data-id="element-126">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-4 p-4 rounded-xl bg-[#1a1a24] border border-white/5" data-id="element-127">
              <div className="p-2 bg-[#ff2d7a]/10 rounded-lg text-[#ff2d7a] flex-shrink-0" data-id="element-128">
                <pain.icon size={20} data-id="element-129" />
              </div>
              <p className="text-gray-300 text-sm sm:text-base" data-id="element-130">{pain.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}